import { useEffect } from 'react';
import { useUserStore } from 'store/user';
import { dataFlushClient } from 'shared/domain/dataFlush/dataFlushClient';
import { projectClient } from 'shared/domain/project/projectClient';
import { refreshUserAndProjectsList } from 'shared/domain/project/refreshUserAndProjectsList';
import { debugLog } from 'shared/logger/debugLog';
import { runUnlessSigningOut } from 'components/core/WithLogout/model';

/** Refetches the user and the project list after the worker dropped stored data. */
export function useDataFlushedSubscription(): void {
  const { authenticate } = useUserStore.use.actions();

  useEffect(() => {
    const stopListeningToDataFlushes = dataFlushClient.onDataFlushed(
      runUnlessSigningOut(() => {
        void authenticate();
        debugLog('download of a missing project list after data flushed');
        projectClient.downloadWhenMissing();
      })
    );
    const stopListeningToProjectFlushes = dataFlushClient.onProjectDataFlushed(
      runUnlessSigningOut(() => {
        refreshUserAndProjectsList(authenticate);
        debugLog('refreshUserAndProjectsList after project data flushed');
      })
    );

    return (): void => {
      stopListeningToDataFlushes();
      stopListeningToProjectFlushes();
    };
  }, [authenticate]);
}
